import axios from "axios"
import { useAuthStore } from "../../../stores/authStore"

const API_URL =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.MODE === "production"
    ? "/api/v1"
    : "http://localhost:8000/api/v1")

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
})

api.interceptors.request.use(
  (config) => {
    const { token } = useAuthStore.getState()

    const publicRoutes = ["/login", "/register", "/refresh"]
    const isPublic = publicRoutes.some((url) => config.url?.endsWith(url))

    if (token && !isPublic) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status
    const originalRequest = error.config

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        useAuthStore.getState().resetAuth()
        if (window.location.pathname !== "/login") {
          window.location.replace("/login")
        }
      } catch (_) {
        useAuthStore.getState().resetAuth()
      }
    }

    return Promise.reject(error)
  }
)

export default api